import { isNumber } from "@bonusmap/shared_ui/library";
import { templateParseToElement } from "../../logic/templateParse.js";
import { AmbitoInputComponent } from "../ambito-input/ambito-input-component.js";
import { DataBaseComponent } from "./data-base-component.js";

export class DataAmbitoComponent extends DataBaseComponent {
    static webComponentName: string = "data-ambito";
    protected _templateId: string = "data-ambito-component"; // Template ID for rendering
    protected inputType: string = "text"; // Default input type for ambito fields
    protected ambitoComponent:AmbitoInputComponent|null=null; // Reference to the ambito input component
    protected rendered: boolean = false;
    get readOnly(): boolean {
        return this.hasAttribute('readonly') || this.hasAttribute('disabled') ||
        this.dataSlotElement?.hasAttribute('readonly') || this.dataSlotElement?.hasAttribute('disabled');
    }
    constructor() {
        super();
    }
    get value(): any {
        if (this.ambitoComponent && this.rendered) {
           
            return this.ambitoComponent.value;
        }
        return super.value;
    }
    set value(newValue: any) {
        super.value = newValue;
    }
    protected setupSyncEventListeners(): void {} // No sync events needed
    addDataForTemplate(): Record<string, any> {
        const initialValue = Array.isArray(this.value) ? this.value.join(', ') : '';
        const maxItemsEl = this.closest('[max-items]');
        const maxItems = maxItemsEl ? parseInt(maxItemsEl.getAttribute('max-items') || '0', 10) : 0;
        return {
            inputType: this.inputType, // Pass the input type to the template
            field:this.field, // Include field metadata
            readonly: this.readOnly, // Pass readOnly state
            maxItems:isNumber(maxItems) && maxItems > 0 ? maxItems : null,
            initialValue
        };
    }
    protected afterRender(): void {
        super.afterRender();
        this.ambitoComponent = this.querySelector<AmbitoInputComponent>('ambito-input');
        if(this.ambitoComponent) {
            this.rendered = true;
        }
    }
    protected render(): void {
        templateParseToElement(this.templateId, this,this.addDataForTemplate());
        this.afterRender();
    }
}